import * as React from 'react';

import { IconButtonMenuIcons } from './icon-button-menu-icons';
import { Styled } from './styled';

export const MenuIcons = React.memo(
  ({ iconId, iconListMap, position, onIconClick }) => {
    return (
      <Styled.ModalWrapper position={position}>
        <Styled.Container position={position}>
          <Styled.List>
            {Object.entries(iconListMap).map(([key, value]) => {
              const isSelected = iconId === key;
              return (
                <IconButtonMenuIcons
                  key={key}
                  id={key}
                  Icon={value}
                  isSelected={isSelected}
                  onClick={onIconClick}
                  defaultColor={isSelected && 'white'}
                />
              );
            })}
          </Styled.List>
        </Styled.Container>
      </Styled.ModalWrapper>
    );
  }
);
